<div class="card">
  <div class="card-header">Listado de {{ entity | uppercase }}</div>
  <div class="card-body">
    <app-fil-venta-usuario #filtro *ngIf="user.rol.id>1" (filter)="doFound($event)"> </app-fil-venta-usuario>
    <app-fil-venta #filtro *ngIf="user.rol.id==1" (filter)="doFound($event)"> </app-fil-venta>

    <div class="row table-responsive">
      <table class="table table-striped table-inverse">
        <thead class="thead-inverse">
          <tr>
            <!-- <th>id</th> -->
            <th>Fecha</th>
            <th>Cliente</th>
            <th>Venta</th>
            <th>Estado</th>
            <th>Condición Compra</th>
            <th>Pago</th>
            <th>Total</th>
            <th>acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <!-- <td scope="row">{{item.id}} </td> -->
            <td>{{ item.created_at | date : "dd-MM-yyyy HH:mm:ss" }}</td>
            <td>{{ item.cliente | uppercase }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.estado }}</td>
            <td>{{ item.condicion }}</td>
            <td>{{ item.pago }}</td>
            <td>{{ item.total }}</td>
            <td>
              <button *ngIf="item.estado == 'pedida' || item.estado == 'editada'" type="button"
                (click)="linkear(item.id)" class="btn btn-info btn-sm">
                <i class="fas fa-edit"></i>
              </button>
              &nbsp;
              <button type="button" (click)="preDelete(item)" class="btn btn-danger btn-sm">
                <i class="fas fa-trash"></i>
              </button>
              &nbsp;
              <button *ngIf="item.estado != 'confirmada'" type="button" (click)="entregar(item)"
                class="btn btn-success btn-sm">
                <i class="fas fa-handshake"></i>
              </button>
              &nbsp;
              <button type="button" (click)="imprimir(item.id)" class="btn btn-warning btn-sm">
                <i class="fas fa-print"></i>
              </button>
            </td>
          </tr>
          <tr class="text-center">
            <td colspan="6">
              TOTAL vendido efectivo
              {{ totalC | currency }}
              || TOTAL vendido mayorista
              {{ totalD | currency }}
              || TOTAL vendido tarjeta
              {{ totalT | currency }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-footer text-muted">
    <div class="btn-group" role="group" aria-label="">
      <a (click)="linkear(0)" class="btn btn-dark">Agregar</a>
    </div>
  </div>
</div>